import HttpConnection from "@/utils/HttpConnection";
export default {
    state: {
        classList: [],
        classListIndex: 0,
    },
    mutations: {
        setClassList(state, params) {
            state.classList = params;
        },
        setClassListIndex(state, params) {
            state.classListIndex = params;
        },
    },
    actions: {
        classerList({ commit, rootState }, params) {
            return new Promise(function (resolve, reject) {
                HttpConnection.get("/teach/classer/teacherlist", {
                    params: {
                        userId: rootState.user.userInfo.userId,
                    },
                }).then(function (response) {
                    let _classList = [];
                    for (let item of response.rows) {
                        item.icon = require("@/assets/menuc08.png");
                        _classList.push(item);
                    }
                    commit("setClassList", _classList);
                    resolve(_classList);
                });
            });
        },
    },
};
